import {TypeStateApiDto} from "./_RestModels";

export default class TypeState {
	constructor(public readonly typeId: string, public readonly quantity: number) {
	}

	public static fromJson(json: TypeStateApiDto): TypeState {
		return new TypeState(json.typeId, json.quantity);
	}
}